import React, { useState } from 'react';
import { 
  Box, 
  Tabs, 
  Tab, 
  Typography,
  Alert
} from '@mui/material';
import {
  People as PeopleIcon,
  Assessment as AssessmentIcon,
  AssignmentInd as AssignmentIndIcon
} from '@mui/icons-material';
import GestionUsuarios from './GestionUsuarios';
import EstadisticasAdmin from './EstadisticasAdmin';
import GestionSolicitudesRol from './GestionSolicitudesRol';

const PanelAdmin = () => {
  const [tabActiva, setTabActiva] = useState(0);

  const handleChange = (event, newValue) => {
    setTabActiva(newValue);
  };

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
        Panel de Administración
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabActiva} onChange={handleChange}>
          <Tab label="Usuarios" icon={<PeopleIcon />} iconPosition="start" />
          <Tab label="Solicitudes de Rol" icon={<AssignmentIndIcon />} iconPosition="start" />
          <Tab label="Estadísticas" icon={<AssessmentIcon />} iconPosition="start" />
        </Tabs>
      </Box>
      
      <Box sx={{ mt: 3 }}>
        {tabActiva === 0 && <GestionUsuarios />}
        {tabActiva === 1 && <GestionSolicitudesRol />}
        {tabActiva === 2 && <EstadisticasAdmin />}
      </Box>
    </Box>
  );
};

export default PanelAdmin; 